import {Cliente, FormPesquisarCliente} from "../Components/Shared/Interfaces/Cliente";
import { ServiceBase } from "./ServiceBase";

export class ClienteService extends ServiceBase {
    
    async getByDocumento(url: string) {
        return this.get(url);
    }

    async getAll(url: string) {
        return this.get(url);
    }

    async postCliente(body: Cliente) {
        let url = '/api/Clientes/Adicionar';
        return this.post(url, body);
    }

    async buscarPor(body: FormPesquisarCliente) {
        let url = '/api/Clientes/BuscarPor'
        return this.post(url, body);
    }

    async putCliente(body: Cliente) {
        let url = `/api/Clientes/Atualizar`;
        // const params = new URLSearchParams();

        // if (body.id !== 0) {
        //     params.append("id", body.id.toString());
        // }
        return this.put(url, body);
    }
    

    async deleteItem(url: string) {
        return this.delete(url)
    }


}